module.exports = __webpack_public_path__ + "media/images/car-key-313536febd207ee9adbd04e62b255fdb.jpeg";